import MenuItemConfigurationModal, { MenuItemConfigurationModalProps } from './MenuItemConfigurationModal';
import withInteractor from './MenuItemConfigurationModal.interactor';
import withPresenter from './MenuItemConfigurationModal.presenter';

export type { MenuItemConfigurationModalProps };
export default withInteractor(withPresenter(MenuItemConfigurationModal));
